import { render, staticRenderFns } from "./Leftnav.vue?vue&type=template&id=53b92bbc&scoped=true&"
import script from "./Leftnav.vue?vue&type=script&lang=js&"
export * from "./Leftnav.vue?vue&type=script&lang=js&"
import style0 from "./Leftnav.vue?vue&type=style&index=0&id=53b92bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b92bbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b92bbc')) {
      api.createRecord('53b92bbc', component.options)
    } else {
      api.reload('53b92bbc', component.options)
    }
    module.hot.accept("./Leftnav.vue?vue&type=template&id=53b92bbc&scoped=true&", function () {
      api.rerender('53b92bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Leftnav.vue"
export default component.exports